import { USERS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth`, // Resolves to BASE_URL + 'users/auth'
        method: 'POST',
        body: data,
      }),
    }),
    googleLogin: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/google-auth`,
        method: 'POST',
        body: data,
      }),
    }),
    register: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}`, // Resolves to BASE_URL + 'users'
        method: 'POST',
        body: data,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout`,
        method: 'POST',
      }),
    }),
    getUserProfile: builder.query({
      query: () => ({
        url: `${USERS_URL}/profile`,
      }),
    }),
    updateUserPassword: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/updatePassword`,
        method: "POST",
        body: data,
      }),
    }),
    sendResetPasswordRequest: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/createResetPasswordRequest`,
        method: "POST",
        body: data
      })
    }),
    resetForgottenPassword: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/resetForgottenPassword`,
        method: "POST",
        body: data
      })
    }),
    verifyEmail: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/verifyUser`,
        method: "POST",
        body: data
      })
    }),
    createVerifcationLink: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/createVerificationLink`,
        method: "POST",
        body: data
      })
    })

  }),
});

export const {
  useLoginMutation,
  useGoogleLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
  useGetUserProfileQuery,
  useUpdateUserPasswordMutation,
  useSendResetPasswordRequestMutation,
  useResetForgottenPasswordMutation,
  useVerifyEmailMutation,
  useCreateVerifcationLinkMutation
} = usersApiSlice;
